<template>
  <div
    ref="registrationFormSteps"
    class="registration-steps"
  >
    <transition
      name="step"
      mode="out-in"
      @before-leave="onBeforeLeave"
      @before-enter="onBeforeEnter"
      @after-enter="onAfterEnter"
    >
      <registration-step-contact-data
        v-if="currentStep === 1"
        key="step-1"
        @valid-changed="(value) => $emit('valid-changed-step-contact-data', value)"
      />
      <registration-step-password
        v-else-if="currentStep === 2"
        key="step-2"
        no-recaptcha
        @valid-changed="(value) => $emit('valid-changed-step-password', value)"
      />
    </transition>
  </div>
</template>

<script>
import RegistrationStepContactData from 'components/registration/fischer/registration-steps/RegistrationStepContactData';
import RegistrationStepPassword from 'components/registration/fischer/registration-steps/RegistrationStepPassword';
import registrationMixin from 'mixins/registrationMixin';

export default {
  name: 'RegistrationLight',
  components: {
    RegistrationStepContactData,
    RegistrationStepPassword,
  },
  mixins: [registrationMixin],
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  emits: ['valid-changed-step-contact-data', 'valid-changed-step-password'],
};
</script>

<style lang="scss">
@import './registration-steps';
</style>
